import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { get } from 'lodash-es';

import { withRouter } from 'react-router-dom';
import { getShareViaYammerSelector } from 'common/selectors/index';
import { getBase64SharePathSelector } from '../selectors';
import { ShareButton } from '../share-button';
import { VivaEngage } from './viva-engage';

const YammerButton = ({ isVisible, onClick }) => (
  <ShareButton
    hidden={!isVisible}
    dataE2e="yammer"
    onClick={onClick}
    customIcon={<VivaEngage style={{ marginRight: 4 }} />}
    label="Viva Engage"
  />
);

const mapStateToProps = (state, props) => {
  const yammerFeature = getShareViaYammerSelector(state);
  const isShareViaYammerEnabled = !!(get(yammerFeature, 'enabled') && get(yammerFeature, 'loaded'));
  const params = props.match && props.match.params;
  const sharePath = getBase64SharePathSelector(params)(state);
  const videoShareUrl = `${window.location.origin}/api/share?p=${sharePath}`;

  return {
    videoShareUrl,
    isShareViaYammerEnabled,
  };
};

const shareOnYammer = (videoShareUrl) => {
  window.yam.platform.yammerShare(window.yam.platform);
  window.yam.platform.yammerShare({
    pageUrl: videoShareUrl,
  });

  const shareButton = window.document.getElementById('yj-share-button').getElementsByTagName('a')[0];

  shareButton.click();
};

const combineProps = ({ videoShareUrl, isShareViaYammerEnabled }) => {
  return {
    isVisible: isShareViaYammerEnabled,
    onClick: () => shareOnYammer(videoShareUrl),
  };
};

export const YammerButtonDecorated = compose(withRouter, connect(mapStateToProps, null, combineProps))(YammerButton);
